<div class="bg-white h-20 rounded-md shadow-md flex items-center px-4 mb-4 animate-pulse">
    <div class="w-10 h-10 bg-gray-200 rounded-full mr-4"></div>
  
    <div class="flex-1 space-y-2">
      <div class="h-4 bg-gray-200 rounded w-1/3"></div>
      <div class="h-3 bg-gray-200 rounded w-1/2"></div>
    </div>
  
    <div class="h-4 bg-gray-200 rounded w-16"></div>
  </div>